/**
 * The auth context object and its type.
 *
 * A React context is a value, not a component, so it cannot live alongside
 * AuthProvider without disabling Fast Refresh for the provider — and the
 * provider sits above the whole app, so every edit to it discarded the user's
 * in-progress wizard state.
 */
import { createContext } from 'react';
import type { AuthState } from '../types/auth';

export interface AuthContextType extends AuthState {
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, betaKey?: string) => Promise<{ requiresVerification: boolean }>;
  logout: () => Promise<void>;
  getAccessToken: () => string | null;
}

export const AuthContext = createContext<AuthContextType | null>(null);
